const Likes = () => {
  return (
    <svg width="14" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".398"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.733c0 .7.597 1.265 1.333 1.265 0 0 6.716.005 7.67 0 2.078.021 3.39-.543 3.955-2 .152-.372.992-3.581 1-3.617.239-1.064-.557-1.993-1.717-1.993H9.835c-.185 0-.307-.14-.27-.312 0 0 .178-.844.217-1.053.146-.783.225-1.399.218-1.816.012-.66-.36-1.214-.95-1.651C8.732.32 8.247.1 8.247.1 7.74-.14 7.136.068 6.9.551c0 0-1.914 3.96-2.073 4.263-.16.303-.576.574-.946.574H1.333C.597 5.388 0 5.954 0 6.653v5.08Zm9.017-.003c1.48.015 2.214-.27 2.588-.952h-.27c-.37 0-.669-.281-.669-.634 0-.35.296-.634.669-.634h.668l.173-.634h-.508c-.37 0-.668-.282-.668-.634 0-.35.295-.634.668-.634h.852l.132-.487c.063-.278-.098-.465-.41-.465H9.834c-1.024 0-1.78-.87-1.577-1.83.007-.033.199-.956.211-1.024.138-.742.203-1.272.197-1.574v-.044c.004-.19-.117-.391-.436-.628a7.4 7.4 0 0 0-.27-.161L6.038 5.347C5.682 6.079 4.848 6.608 4 6.653v5.08l5.017-.003Zm-6.35-5.074H1.333v5.077h1.334V6.656Z"
        fill="#fff"
      />
    </svg>
  );
};
export default Likes;
